import storage from 'utils/storage';

export const IS_TEST_ENV = ['stage', 'develop'].includes(
  process.env.REACT_APP_MODE,
);

export const SERVER_ADDRESS_TYPES = {
  MAIN: 'main',
  TEST: 'test',
};
export const IS_TEST_SERVER_URL =
  storage.get('serverUrl') === SERVER_ADDRESS_TYPES.TEST;

export const SOCKET_URL =
  IS_TEST_ENV && IS_TEST_SERVER_URL
    ? process.env.REACT_APP_TEST_SOCKET_URL
    : process.env.REACT_APP_SOCKET_URL;

export const BASE_URL =
  IS_TEST_ENV && IS_TEST_SERVER_URL
    ? process.env.REACT_APP_TEST_BASE_URL
    : process.env.REACT_APP_BASE_URL;

export const API_URL =
  IS_TEST_ENV && IS_TEST_SERVER_URL
    ? process.env.REACT_APP_TEST_API_URL
    : process.env.REACT_APP_API_URL;

export const VEHICLE = {
  0: 'all',
  1: 'hasDevice',
  2: 'hasRobot',
};

export const VEHICLE_CONTROL = {
  1: 'deleteFaultCodes',
  2: 'manualDiag',
  DELETE_FAULT_CODE: 1,
  MANUAL_DIAG: 2,
};

export const GMINDER_TYPES = {
  POLYGON: 1,
  RADIUS: 2,
};

export const ZOOM_LEVEL = 14;
export const RADIUS_FACTOR = 10;
export const PHI = 1.61803398875;
export const INFINITE_SCROLL_COUNT = 10;
export const TYPE_SPEED = 400;
export const PLAQUE_OPTIONS = [
  'الف',
  'ب',
  'پ',
  'ت',
  'ث',
  'ج',
  'د',
  'ز',
  'س',
  'ش',
  'ص',
  'ط',
  'ع',
  'ف',
  'ق',
  'ک',
  'گ',
  'ل',
  'م',
  'ن',
  'و',
  'ه',
  'ی',
  'M', // maelolin
  'T', // tashrifat
  'D', // diplomat
  'S', // security
];

// export const boxShadow = p =>
//   `box-shadow: 0 ${PHI / 20}rem ${PHI / 12}rem ${rgba(
//     p.theme.colors.blackColor,
//     0.15,
//   )};`;

// export const active = p =>
//   `box-shadow: 0 0 0 ${PHI / 8}rem ${rgba(
//     p.theme.colors.tertiaryColor,
//     0.9,
//   )} inset;`;

// export const radius = {
//   tiny: `${PHI * 3}px`,
//   small: `${PHI * 6}px`,
//   medium: `${PHI * 24}px`,
//   high: '50%',
// };

// export const typography = {
//   smallX: `font-size: ${PHI * 0.5}rem`, // 0.8
//   small: `font-size: ${PHI}rem`,
//   medium: `font-size: ${PHI * 1.4}rem`,
//   large: `font-size: ${PHI * 1.8}rem`,
//   largeX: `font-size: ${PHI * 2.2}rem`,
//   large2X: `font-size: ${PHI * 2.4}rem`,
//   large3X: `font-size: ${PHI * 2.8}rem`,
//   large4X: `font-size: ${PHI * 4.0}rem`,
// };

// export const transition = () =>
//   `
//     transition: ease 0.3s;
//   `;
